import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Location } from './location.model';
import { Room } from '../room/room.model';
import * as moment from 'moment';

@Injectable()
export class LocationService {
    resourceUrl = '/api/locations';

    constructor(private http: HttpClient) {}

    create(location): Observable<any> {
        return this.http.post<any>('api/locations/', location);
    }

    update(location): Observable<Location[]> {
        return this.http
            .put<Location[]>('/api/locations/' + location.id, location)
            .pipe(
                catchError((error: any) =>
                    observableThrowError(error.message || 'Server error')
                )
            );
    }

    findAll(): Observable<Location[]> {
        return this.http.get<Location[]>('/api/locations');
    }

    findById(id): Observable<Location> {
        return this.http.get<Location>('/api/locations/' + id);
    }

    findRoomsById(id): Observable<Room[]> {
        return this.http.get<Room[]>('/api/locations/' + id + '/rooms');
    }

    findAllZenika(): Observable<Location[]> {
        return this.http.get<Location[]>('/api/zenika-locations');
    }

    findAllPartner(): Observable<Location[]> {
        return this.http.get<Location[]>('/api/partner-locations');
    }

    searchPartners(keyword: string): Observable<Location[]> {
        return this.http.get<Location[]>(
            `/api/partner-locations/search?keyword=${keyword}`
        );
    }

    findUnavailableRoomsForWeek(date): Observable<any> {
        return this.http.get<any>(
            this.resourceUrl +
                '/unavailable/rooms?date=' +
                moment(date).format('YYYY-MM-DD')
        );
    }

    saveRoom(location: Location, room: Room): Observable<any> {
        return this.http.put(
            '/api/locations/' + location.id + '/rooms/' + room.id,
            room
        );
    }

    createRoom(location: Location, room: Room): Observable<any> {
        return this.http.post('/api/locations/' + location.id + '/rooms', room);
    }

    removeRoom(location: Location, room: Room): Observable<any> {
        return this.http.delete(
            '/api/locations/' + location.id + '/rooms/' + room.id
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/location/location.service.ts